import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Radio from "../../../atoms/Radio";
import SourceEntity from "../../models/SourceEntity";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import Autocomplete from "../../../atoms/Autocomplete";
import EntityOption from "./EntityOption";

function EntitySelector({ entities, selectedEntity, selectEntity }) {
  const options = useMemo(() => {
    return (entities || []).filter(Boolean);
  }, [entities]);

  return options?.length > 2 ? (
    <Autocomplete
      value={selectedEntity}
      optionKey="id"
      className="tw-border tw-border-blueGray-300 tw-flex tw-items-center tw-pr-2"
      options={options}
      onSelect={selectEntity}
      OptionsWrapper={({ children }) => (
        <div className="tw-bg-white tw-max-h-66 tw-overflow-auto tw-rounded tw-mt-2 tw-border tw-border-blueGray-300 tw-shadow-strong">
          {children}
        </div>
      )}
      OptionContent={({ option, isHighlighted }) => {
        const cl = isHighlighted
          ? "tw-bg-blueGray-200 tw-text-blueGray-900"
          : "";
        return (
          <div
            className={`prevent-tooltip-close tw-py-1 tw-cursor-pointer tw-px-2 ${cl}`}
          >
            <EntityOption entity={option} />
          </div>
        );
      }}
    />
  ) : (
    <div className="">
      {options.map((x) => (
        <Radio
          key={x.id}
          id={String(x.id)}
          name="select-entity"
          value={String(x.id)}
          handleSelection={() => selectEntity(x)}
          isSelected={selectedEntity?.id === x.id}
        >
          <EntityOption entity={x} showGeneLink={true} />
        </Radio>
      ))}
    </div>
  );
}

EntitySelector.propTypes = {
  entities: PropTypes.arrayOf(PropTypes.instanceOf(SourceEntity)),
  selectedEntity: PropTypes.instanceOf(SourceEntity),
  selectEntity: PropTypes.func.isRequired,
};

EntitySelector.defaultProps = {
  entities: [],
  selectedEntity: null,
};

export default withErrorGuard(
  React.memo(EntitySelector),
  "EntitySelector",
  "EntitySelector"
);
